<div class="cohort-viewer">

  <div class="cohort-header">
    <div class="triangle" *ngIf="!visible" (click)="visible = true">&#x25B6;</div>
    <div class="triangle" *ngIf="visible" (click)="visible = false">&#x25BC;</div>
    <div class="cohort-title">{{cohort.name}}</div>
    <div class="spacer"></div>
    <i *ngIf="editMode" class="fa fa-pencil"(click)="enterEditMode()" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Edit'"></i>
    <i *ngIf="enableCohortDragging" class="fa fa-bars" genTooltip [tooltipPosition]="'BOTTOM'" [appendToBody]="true" [tooltipText]="'Drag to change priority'"></i>
  </div>

  <div class="table" *ngIf="visible">
    <div class="row">
      <div class="key">Status</div>
      <div class="value">{{cohort.info.status.display}}</div>
    </div>
    <div class="row">
      <div class="key">Drugs</div>
      <div class="drugs">{{getDrugs()}}</div>
    </div>
  </div>

  <div *ngIf="visible" class="criterion-viewer-list" >
    <gen-criterion-viewer *ngFor="let criterion of cohort.criteria; let first = first"
                          [criterion]="criterion"
                          [first]="first"
    ></gen-criterion-viewer>
  </div>

</div>
